/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/timing/quiet_hours" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdTimingQuietHours } from "./constants";
import type { GetDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHours = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdTimingQuietHours,
  (
    signal: AbortSignal,
    appGroupId: string,
    dsaId: string
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/timing/quiet_hours`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult
);
